/*
 * CSS Module demo (ARCHITECTURE §5): genuinely-scoped, keyframe-heavy styling lives in
 * a .module.css co-located with its component. Uses the Figma token CSS variables
 * directly (var(--color-…)), so no @reference/@apply is needed here.
 */
.shimmer {
  background: linear-gradient(
    90deg,
    var(--color-surface) 25%,
    var(--color-surface-raised) 37%,
    var(--color-surface) 63%
  );
  background-size: 400% 100%;
  animation: shimmer 1.4s ease infinite;
}

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .shimmer {
    animation: none;
  }
}
